/**
 * Filter for Profile Name it the name is too long
 */
const filter = () => {
    return (input) => {
        let output = angular.isDefined(input) ? input : "";
        if (output.length > 65) {
            return output.substring(0, 65) + "...";
        }
        else {
            return output;
        }
    };
};
const ɵ0 = filter;
export const CompanyNameSettingsFilter = {
    name: 'companyNameSettingsFilter',
    filter: filter
};
export { ɵ0 };
//# sourceMappingURL=fourdotfive-company-name-settings.filter.js.map